import { useSearchParams } from "react-router-dom";
import { Tabs, Typography } from "antd";
import RunningInstances from "./RunningInstances";
import WorkflowTasks from "../WorkflowTasks";
import WorkflowAdmin from "../Workflow";

const { Title, Paragraph } = Typography;

const VALID_TABS = ["running", "mine", "admin"];

/**
 * Single entry point for everything workflow-related:
 *   - Running   : live dashboard of in-flight workflow instances
 *   - My Approvals : the signed-in user's pending tasks
 *   - Configure : workflow definitions + triggers (admin)
 */
export default function Workflows() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab");
  const activeKey = VALID_TABS.includes(tab) ? tab : "running";

  return (
    <div style={{ padding: 16, maxWidth: 1200 }}>
      <Title level={3} style={{ marginTop: 0 }}>Workflows</Title>
      <Paragraph type="secondary">
        Monitor running workflows, act on approvals assigned to you, and configure
        automations that fire when records are created or updated.
      </Paragraph>
      <Tabs
        activeKey={activeKey}
        onChange={(key) => setSearchParams(key === "running" ? {} : { tab: key })}
        items={[
          { key: "running", label: "Running", children: <RunningInstances /> },
          { key: "mine", label: "My Approvals", children: <WorkflowTasks embedded /> },
          { key: "admin", label: "Configure", children: <WorkflowAdmin embedded /> },
        ]}
      />
    </div>
  );
}
